import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

import { UPLOADS_SLICE_NAME } from './uploadsSliceName';
import { UploadsState, UPLOADS_INITIAL_STATE } from './uploadsState';
import { UploadStatus } from './uploadStatus';
import { uploadFile } from './thunks';

const uploadsSlice = createSlice({
  name: UPLOADS_SLICE_NAME,
  initialState: UPLOADS_INITIAL_STATE,
  reducers: {
    setProgress: (state, action: PayloadAction<{ id: string; progress: number }>) => {
      const item = state.items[action.payload.id];

      if (item) {
        item.progress = action.payload.progress;
      }
    },

    removeUpload: (state, action: PayloadAction<string>) => {
      delete state.items[action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFile.pending, (state, action) => {
        const { id, tag, file } = action.meta.arg;

        state.items[id] = {
          id,
          tag,
          fileName: file.name,
          fileSize: file.size,
          progress: 0,
          status: UploadStatus.UPLOADING,
        };
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        const item = state.items[action.meta.arg.id];

        if (item) {
          item.progress = 100;
          item.status = UploadStatus.SUCCEEDED;
        }
      })
      .addCase(uploadFile.rejected, (state, action) => {
        const item = state.items[action.meta.arg.id];

        if (item) {
          item.status = UploadStatus.FAILED;
          item.error = action.payload;
        }
      });
  },
});

export const { removeUpload } = uploadsSlice.actions;
export const uploadsReducer: Reducer<UploadsState> = uploadsSlice.reducer;
